import React from 'react';
import PropTypes from 'prop-types';
import SignaturePreview from 'SignatureManager/SignaturePreview';
import SignatureCreator from 'SignatureManager/SignatureCreator';

const uuidV4 = require('uuid/v4');

export default class SignatureManager extends React.Component {
  static clearInput() {
    if (document.getElementById('sig-text')) {
      document.getElementById('sig-text').textContent = '';
    }
  }

  static getTypeInputValue() {
    const sigTextEl = document.getElementById('sig-text');
    // Skip if no input
    if (!sigTextEl || !sigTextEl.value) {
      return null;
    }
    return sigTextEl.value;
  }


  constructor(props) {
    super(props);
    this.closeCreator = this.closeCreator.bind(this);
    this.openCreator = this.openCreator.bind(this);
    this.openUpload = this.openUpload.bind(this);
    this.getPreviewData = this.getPreviewData.bind(this);
    this.saveTypeSignature = this.saveTypeSignature.bind(this);
    this.saveImageSignature = this.saveImageSignature.bind(this);
    this.saveUploadImage = this.saveUploadImage.bind(this);
    this.useSignature = this.useSignature.bind(this);
    this.renderButtons = this.renderButtons.bind(this);
    this.removeSignature = this.removeSignature.bind(this);
    this.handleSignatureEnterPress = this.handleSignatureEnterPress.bind(this);

    this.state = {
      displayCreator: false,
      creatorType: null,
    };

    this.isTouchDevice = (!!('ontouchstart' in window) || !!(navigator.maxTouchPoints > 0));
  }

  componentWillMount() {
    if (!this.props.loadFromSave) {
      this.props.getSignatures(this.props.isSingleSignatureMode);
    }
  }

  componentDidMount() {
    window.addEventListener('keypress', this.handleSignatureEnterPress);
  }

  componentWillReceiveProps(nextProps) {
    const displayCreatorDiffers = nextProps.displayCreator !== this.props.displayCreator;
    const creatorTypeDiffers = nextProps.creatorType !== this.props.creatorType;
    if (displayCreatorDiffers || creatorTypeDiffers) {
      this.setState({
        displayCreator: nextProps.displayCreator,
        creatorType: nextProps.creatorType,
      });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('keypress', this.handleSignatureEnterPress);
  }

  getPreviewData(previewType) {
    const imgSrc = this.props.imageUrls[previewType];
    const submitCreatorFunc = previewType === 'upload' ?
                              this.openUpload :
                              () => { this.openCreator(previewType); };

    return {
      imageUrl: imgSrc,
      type: previewType,
      visible: this.props.alwaysShowPreviewData || !this.state.displayCreator,
      buttonText: this.props.buttonText[previewType],
      buttonChildren: this.props.buttonChildren[previewType],
      forSigning: this.props.forSigning,
      submitCreator: submitCreatorFunc,
      submitPopup: (type, e) => { this.props.imageClick(imgSrc, previewType, e); },
      submitClear: (type, e) => { this.removeSignature(e, previewType); },
      title: this.props.previewTitles[previewType],
    };
  }

  handleSignatureEnterPress(e) {
    if (this.props.isSelfServe && e.key === 'Enter') {
      this.useSignature(e);
    }
  }

  removeSignature(e, previewType) {
    if (this.props.preventFormSubmit) {
      // Prevent default form submit for self-serve
      e.preventDefault();
    }
    if (this.props.isSelfServe) {
      window._track('Remove Signature | Recipient Builder', 'Recipient Builder');
    }
    this.props.removeSignature(previewType);
    if (this.props.afterRemoveSignatureAction) {
      this.props.afterRemoveSignatureAction();
    }
  }

  closeCreator() {
    this.setState({ displayCreator: false, creatorType: null });
    if (this.props.closeCreatorAction) {
      this.props.closeCreatorAction();
    }
    setTimeout(window.setMainContainerHeight, 0);
  }

  openCreator(type) {
    if (this.props.trackSelectFunction) {
      this.props.trackSelectFunction(type);
    }
    this.setState({ displayCreator: true, creatorType: type });
    if (this.props.openCreatorAction) {
      this.props.openCreatorAction();
    }
    setTimeout(window.setMainContainerHeight, 0);
  }

  openUpload() {
    if (this.props.trackSelectFunction) {
      this.props.trackSelectFunction('upload');
    }
    this.uploadInput.click();
  }

  attachImageToMouse(type) {
    const img = new Image();
    const imgSrc = this.props.imageUrls[type];
    img.src = imgSrc;
    img.onload = () => {
      this.props.createSigPopup(imgSrc, uuidV4(), window.getPageIndex(), img.width, 0, 0);
      window.attachImgToMouse();
    };
  }

  saveTypeSignature(textVal) {
    this.props.saveTypeSignature(textVal, 'sig-text', this.props.isSingleSignatureMode)
      .then(() => {
        SignatureManager.clearInput();
        this.setState({ displayCreator: false, creatorType: null });
        if (this.props.closeCreatorAction) {
          this.props.closeCreatorAction();
        }
        if (this.props.attachToMouse) {
          this.attachImageToMouse('type');
        }
        if (this.props.afterSaveSignatureAction) {
          this.props.afterSaveSignatureAction('type');
        }
      })
      .catch(() => {
        this.setState({ displayCreator: false, creatorType: null });
      });
  }

  saveImageSignature(imageSrc, type) {
    const signaturePayload = { sig_image: imageSrc };

    this.props.saveSignature(signaturePayload, type, this.props.isSingleSignatureMode)
      .then(() => {
        this.setState({ displayCreator: false, creatorType: null });
        if (this.props.closeCreatorAction) {
          this.props.closeCreatorAction();
        }
        if (this.props.attachToMouse) {
          this.attachImageToMouse(type);
        }
        if (this.props.afterSaveSignatureAction) {
          this.props.afterSaveSignatureAction(type);
        }
      })
      .catch(() => {
        this.setState({ displayCreator: false, creatorType: null });
      });
  }

  saveUploadImage(e) {
    e.preventDefault();

    const reader = new FileReader();

    reader.readAsDataURL(e.target.files[0]);

    reader.onloadend = () => {
      this.saveImageSignature(reader.result, 'upload');
    };
    if (this.props.trackUsageFunction) {
      this.props.trackUsageFunction('upload');
    }
  }

  useSignature(e) {
    if (this.props.preventFormSubmit) {
      // Prevent default form submit for self-serve
      e.preventDefault();
    }
    if (this.props.trackUsageFunction) {
      this.props.trackUsageFunction(this.state.creatorType);
    }
    switch (this.state.creatorType) {
      case 'type': {
        const typeValue = SignatureManager.getTypeInputValue();
        if (!typeValue) {
          return false;
        }
        this.saveTypeSignature(typeValue);
        break;
      }
      case 'draw': {
        const src = this.sigCreator.saveCanvas();
        this.saveImageSignature(src, 'draw');
        break;
      }
      default:
        return false;
    }

    return true;
  }

  renderButtons() {
    return this.state.displayCreator ?
      (
        <this.props.creatorButtons
          closeCreator={this.closeCreator}
          useSignature={this.useSignature}
          {...this.props.creatorButtonProps}
        />
      ) :
      (
        <this.props.previewButtons
          imageUrls={this.props.imageUrls}
          {...this.props.previewButtonProps}
        />
      );
  }

  render() {
    const sigClass = `${this.props.signatureManagerClass}${
      this.state.displayCreator ?
      ` ${this.state.creatorType}-creator` :
      ''
    }`;

    return (
      <React.Fragment>
        <div className={sigClass}>
          { this.props.types.type &&
            <SignaturePreview
              {...this.getPreviewData('type')}
            />
          }
          { this.props.types.draw &&
            <SignaturePreview
              {...this.getPreviewData('draw')}
            />
          }
          { this.props.types.upload &&
            <React.Fragment>
              <SignaturePreview
                {...this.getPreviewData('upload')}
              />
              <a style={{ display: 'none' }}>
                <input
                  type="file"
                  name="file"
                  accept="image/*"
                  ref={(input) => { this.uploadInput = input; }}
                  onChange={(e) => { this.saveUploadImage(e); }}
                />
              </a>
            </React.Fragment>
          }
          <SignatureCreator
            type={this.state.creatorType}
            visible={this.state.displayCreator}
            isTouchDevice={this.isTouchDevice}
            typeLabel={this.props.typeCreatorLabel}
            drawLabel={this.props.drawCreatorLabel}
            clearBtnText={this.props.clearBtnText}
            sigPadHeight={this.props.sigPadHeight}
            sigPadWidth={this.props.sigPadWidth}
            ref={(c) => { this.sigCreator = c; }}
          />
        </div>
        <div className={this.props.buttonClass}>
          {this.renderButtons()}
        </div>
      </React.Fragment>
    );
  }
}

SignatureManager.propTypes = {
  alwaysShowPreviewData: PropTypes.bool,
  afterRemoveSignatureAction: PropTypes.func,
  afterSaveSignatureAction: PropTypes.func,
  attachToMouse: PropTypes.bool,
  buttonChildren: PropTypes.shape({
    type: PropTypes.node,
    draw: PropTypes.node,
    upload: PropTypes.node,
  }),
  buttonClass: PropTypes.string,
  buttonText: PropTypes.shape({
    type: PropTypes.string,
    draw: PropTypes.string,
    upload: PropTypes.string,
  }),
  clearBtnText: PropTypes.string,
  closeCreatorAction: PropTypes.func,
  createSigPopup: PropTypes.func,
  creatorButtonProps: PropTypes.shape(),
  creatorType: PropTypes.string,
  displayCreator: PropTypes.bool,
  drawCreatorLabel: PropTypes.string,
  forSigning: PropTypes.bool,
  getSignatures: PropTypes.func.isRequired,
  imageClick: PropTypes.func,
  imageUrls: PropTypes.shape({
    draw: PropTypes.string,
    type: PropTypes.string,
    upload: PropTypes.string,
  }).isRequired,
  isSelfServe: PropTypes.bool,
  isSingleSignatureMode: PropTypes.bool,
  loadFromSave: PropTypes.bool,
  openCreatorAction: PropTypes.func,
  preventFormSubmit: PropTypes.bool,
  previewButtonProps: PropTypes.shape(),
  previewTitles: PropTypes.shape({
    type: PropTypes.string,
    draw: PropTypes.string,
    upload: PropTypes.string,
  }),
  removeSignature: PropTypes.func.isRequired,
  saveSignature: PropTypes.func.isRequired,
  saveTypeSignature: PropTypes.func.isRequired,
  signatureManagerClass: PropTypes.string,
  sigPadHeight: PropTypes.number,
  sigPadWidth: PropTypes.number,
  trackSelectFunction: PropTypes.func,
  trackUsageFunction: PropTypes.func,
  typeCreatorLabel: PropTypes.string,
  types: PropTypes.shape({
    draw: PropTypes.bool,
    type: PropTypes.bool,
    upload: PropTypes.bool,
  }),
};

SignatureManager.defaultProps = {
  alwaysShowPreviewData: false,
  afterRemoveSignatureAction: null,
  afterSaveSignatureAction: null,
  attachToMouse: false,
  buttonChildren: {
    type: null,
    draw: null,
    upload: null,
  },
  buttonClass: 'buttons',
  buttonText: {
    type: null,
    draw: null,
    upload: null,
  },
  clearBtnText: 'Clear',
  closeCreatorAction: null,
  createSigPopup: null,
  creatorButtons: null,
  creatorButtonProps: null,
  creatorType: null,
  displayCreator: false,
  drawCreatorLabel: null,
  forSigning: false,
  imageClick: () => {},
  isSelfServe: false,
  isSingleSignatureMode: false,
  loadFromSave: false,
  openCreatorAction: null,
  preventFormSubmit: false,
  previewButtons: null,
  previewButtonProps: null,
  previewTitles: {
    type: null,
    draw: null,
    upload: null,
  },
  signatureManagerClass: '',
  sigPadHeight: null,
  sigPadWidth: null,
  trackSelectFunction: null,
  trackUsageFunction: null,
  typeCreatorLabel: null,
  types: {
    draw: false,
    type: false,
    upload: false,
  },
};



// WEBPACK FOOTER //
// ./src-react/SignatureManager/index.jsx